import React from "react";
import { Box } from "@mui/material";
import { CardTitle, cardSx } from "../../HomePage/DashboardCard";

interface Props {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const VoicesCard: React.FC<Props> = ({ title, subtitle, action, children }) => (
  <Box component="section" sx={{ ...cardSx, p: { xs: 2, md: 2.5 }, mb: 3 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
        mb: 2.5,
      }}
    >
      <CardTitle title={title} subtitle={subtitle} />
      {action}
    </Box>
    {children}
  </Box>
);

export default VoicesCard;
